// extracted by mini-css-extract-plugin
export default {"fs":"_64326969d9 _71e83671fc"};